export default __webpack_public_path__ + "static/media/L_Lapis.72128c8d.mp3";